import { css } from 'styled-components'

export const socialNumberFieldStyle = css`
	width: 100%;
`
